import { useAuthStore } from '../auth';
import { AppShell } from '../components/AppShell';

export function PendingPage() {
  const me = useAuthStore((s) => s.me);

  return (
    <AppShell>
      <div className="mx-auto max-w-2xl">
        <div className="card">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-amber-500/30 bg-amber-500/10 px-3 py-1 text-xs font-medium uppercase tracking-wider text-amber-300">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-amber-400" />
            Awaiting approval
          </div>
          <h1 className="text-2xl font-bold">
            {me?.org.name} is pending review
          </h1>
          <p className="mt-3 text-muted">
            A ScoreLync platform admin will activate your organization shortly.
            You'll get access to the dashboard, venues, displays, and the
            scoring engine as soon as your account is approved.
          </p>
          <dl className="mt-6 grid grid-cols-2 gap-4 text-sm">
            <div>
              <dt className="text-xs uppercase tracking-wider text-muted">
                Organization
              </dt>
              <dd className="mt-1 text-text">{me?.org.name}</dd>
            </div>
            <div>
              <dt className="text-xs uppercase tracking-wider text-muted">
                Slug
              </dt>
              <dd className="mt-1 font-mono text-text">{me?.org.slug}</dd>
            </div>
            <div>
              <dt className="text-xs uppercase tracking-wider text-muted">
                Signed in as
              </dt>
              <dd className="mt-1 text-text">{me?.user.email}</dd>
            </div>
            <div>
              <dt className="text-xs uppercase tracking-wider text-muted">
                Role
              </dt>
              <dd className="mt-1 text-text">{me?.user.role}</dd>
            </div>
          </dl>
        </div>
      </div>
    </AppShell>
  );
}
